import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/header";
import { useAuth } from "../hooks/AuthContext";
import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import Menu from "../components/Menu";
const { Sider } = Layout;

const RouteAdmin = () => {
  const user = useAuth();

  useEffect(() => {
    let type = "";
    if (user.user) {
      type = user.user.type;
    }

    if (!type) {
      window.location.assign("/login");
    } else {
      if (type != "admin") {
        if (type == "tecnico") {
          window.location.assign("/tecnico/home");
        } else {
          if (type == "atendente") {
            window.location.assign("/atendente/home");
          } else {
            if (type == "associado") {
              window.location.assign("/associado/home");
            } else {
              window.location.assign("/cliente/home");
            }
          }
        }
      }
    }
  }, []);

  let type = "";
  if (user.user) {
    type = user.user.type;
  }

  return type == "admin" ? (
    <Layout>
      <Header sidebar={true} />
      <Layout>
        <Sider
          style={{ background: "#008037", minHeight: "calc(100vh - 70px" }}
          width={230}
          trigger={null}
          collapsedWidth={0}
          breakpoint={"xl"}
        >
          <Menu />
        </Sider>
        <Content className="content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  ) : (
    <></>
  );
};

export default RouteAdmin;
